<template>
  <v-container
    fluid
    class="px-5 py-0"
  >
    <v-row
      align="center"
      class="ma-0 flex-nowrap timeline__row"
    >
      <v-btn
        :disabled="prevIsDisabled"
        @click="onPrevClick"
        fab
        x-small
        color="primary"
      >
        <v-icon v-text="$vuetify.icons.values['mdiChevronLeft']"/>
      </v-btn>
      <v-row
        align="center"
        class="ma-0 timeline__wrapper fill-height"
      >
        <ul class="timeline" id="timeline">
          <li
            :key="processing['id_processing']"
            v-for="processing in processings"
          >
            <processings-timeline-item
              :processing="processing"
            />
          </li>
        </ul>
      </v-row>
      <v-btn
        :disabled="nextIsDisabled"
        @click="onNextClick"
        fab
        x-small
        color="primary"
      >
        <v-icon v-text="$vuetify.icons.values['mdiChevronRight']"/>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
  import {isEmpty} from "lodash/lang"
  import {forEach, sortBy} from "lodash/collection"
  import ProcessingsTimelineItem from "./ProcessingsTimelineItem"
  import {listIntersectedProcessings} from "../../../api/api-project"

  const _Processing = Symbol.for("_Processing")

  export default {
    name: "ProcessingsTimeline",
    inject: {_Processing},
    components: {ProcessingsTimelineItem},
    data() {
      return {
        isLoading: true,
        processings: [],
        prevIsDisabled: false,
        nextIsDisabled: false,
      }
    },
    methods: {
      async onMounted() {
        await listIntersectedProcessings(this.$apiAuth.getAuthToken(), this.Processing["id_processing"])
          .then((res) => {
            this.processings = sortBy(res.data.data, processing => (new Date(processing["dh_created"])))
          })
      },
      prevNextHandler(event) {
        const timeline = document.getElementById("timeline")
        const timelineElements = document.getElementsByTagName("li")
        if (isEmpty(timelineElements)) {
          this.prevIsDisabled = true
          this.nextIsDisabled = true
          return
        }

        const firstElement = timelineElements[0]
        const lastElement = timelineElements[timelineElements.length - 1]
        if (!firstElement || !lastElement) {
          this.prevIsDisabled = true
          this.nextIsDisabled = true
          return
        }

        this.$nextTick(() => {
          let value
          if (event === "prev")
            value = -60
          else
            value = 60
          this.prevIsDisabled = lastElement.getBoundingClientRect().left + value <= timeline.offsetWidth
          this.nextIsDisabled = firstElement.getBoundingClientRect().left + value >= 85
        })
      },
      onPrevClick() {
        const timelineElements = document.getElementsByTagName("li")
        forEach(timelineElements, el => {
          const style = window.getComputedStyle(el),
            width = el.offsetWidth, // or use style.width
            margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight)

          let transform = window.getComputedStyle(el).transform || 0
          if (transform === "none") transform = -el.offsetWidth
          else transform = parseInt(transform.split('(')[1].split(',')[4])
          transform = transform - (width + margin)
          el.style.transform = `translate(${transform}px, -50%)`
        })
        this.$emit("prev-next-changed", "prev")
      },
      onNextClick() {
        const timelineElements = document.getElementsByTagName("li")
        forEach(timelineElements, el => {
          const style = window.getComputedStyle(el),
            width = el.offsetWidth, // or use style.width
            margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight)

          let transform = window.getComputedStyle(el).transform || 0
          if (transform === "none") transform = 30
          else transform = parseInt(transform.split('(')[1].split(',')[4])
          transform = transform + (width + margin)
          el.style.transform = `translate(${transform}px, -50%)`
        })
        this.$emit("prev-next-changed", "next")
      },
    },
    mounted() {
      this.onMounted().then(() => {
        window.addEventListener('resize', this.prevNextHandler);
        this.$on("prev-next-changed", this.prevNextHandler)
        this.$emit("prev-next-changed")
      })
    },
    computed: {
      Processing() {
        return this._Processing()
      }
    }
  }
</script>

<style scoped lang="scss">

  .timeline__row {
    height: 120px;
  }

  .timeline__wrapper {
    width: 100%;
    overflow-x: hidden;
  }

  .timeline {
    white-space: nowrap;
    position: relative;
    transition: all 0.5s;
    width: 100%;
    height: 2px;
    background: var(--v-primary-base);
    box-shadow: 0 0 2px black;
  }

  .timeline li {
    list-style: none;
    display: inline-flex;
    justify-content: center;
    margin: 0 50px;
    width: auto;
    transition: all 0.5s;
    top: 0;
    transform: translateY(-50%);
  }

</style>
